export const MODEL_OPTIONS = {
  seedream: {
    resolutionLabel: 'Resolution',
    aspectRatioLabel: 'Aspect ratio',
    defaultResolution: '1k',
    defaultAspectRatio: 'auto',
    resolutions: [
      { value: '1k', label: '1K' },
      { value: '1.5k', label: '1.5K' },
      { value: '2k', label: '2K' },
    ],
    aspectRatios: [
      { value: 'auto', label: 'Auto - Let model decide' },
      { value: '1:1', label: '1:1' },
      { value: '16:9', label: '16:9' },
      { value: '9:16', label: '9:16' },
      { value: '4:3', label: '4:3' },
      { value: '3:4', label: '3:4' },
      { value: '3:2', label: '3:2' },
      { value: '2:3', label: '2:3' },
      { value: '4:5', label: '4:5' },
      { value: '5:4', label: '5:4' },
      { value: '2:1', label: '2:1' },
      { value: '1:2', label: '1:2' },
      { value: '3:1', label: '3:1' },
      { value: '1:3', label: '1:3' },
      { value: '21:9', label: '21:9' },
      { value: '9:21', label: '9:21' },
    ],
  },
  'gpt-image-2': {
    resolutionLabel: 'Resolution',
    aspectRatioLabel: 'Aspect Ratio',
    defaultResolution: '1k',
    defaultAspectRatio: '1:1',
    resolutions: [
      { value: '1k', label: '1K' },
      { value: '2k', label: '2K' },
      { value: '4k', label: '4K' },
    ],
    aspectRatios: [
      { value: '1:1', label: '1:1' },
      { value: '1:2', label: '1:2' },
      { value: '2:1', label: '2:1' },
      { value: '1:3', label: '1:3' },
      { value: '3:1', label: '3:1' },
      { value: '2:3', label: '2:3' },
      { value: '3:2', label: '3:2' },
      { value: '3:4', label: '3:4' },
      { value: '4:3', label: '4:3' },
      { value: '4:5', label: '4:5' },
      { value: '5:4', label: '5:4' },
      { value: '9:16', label: '9:16' },
      { value: '16:9', label: '16:9' },
      { value: '9:21', label: '9:21' },
      { value: '21:9', label: '21:9' },
    ],
  },
  'seedance-2.5': {
    resolutionLabel: 'Resolution',
    aspectRatioLabel: 'Aspect Ratio',
    defaultResolution: '720p',
    defaultAspectRatio: '16:9',
    resolutions: [
      { value: '480p', label: '480p' },
      { value: '720p', label: '720p' },
      { value: '1080p', label: '1080p' },
      { value: '4k', label: '4K' },
    ],
    aspectRatios: [
      { value: '16:9', label: '16:9' },
      { value: '9:16', label: '9:16' },
      { value: '4:3', label: '4:3' },
      { value: '3:4', label: '3:4' },
      { value: '1:1', label: '1:1' },
      { value: '21:9', label: '21:9' },
    ],
  },
};

export const DEFAULT_IMAGE_MODELS = [
  { id: 'seedream', label: 'Seedream 5 Pro' },
  { id: 'gpt-image-2', label: 'GPT Image 2' },
];

export const DEFAULT_VIDEO_MODELS = [{ id: 'seedance-2.5', label: 'Seedance 2.5' }];

export const DEFAULT_AVAILABLE_MODELS = [...DEFAULT_IMAGE_MODELS, ...DEFAULT_VIDEO_MODELS];

export const DEFAULT_VIDEO_DURATION = 5;

export const clampVideoDuration = (value, fallback = DEFAULT_VIDEO_DURATION) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(30, Math.max(1, Math.round(n)));
};

export const pickListedModel = (models, current, fallbackId) => {
  if (models.some((model) => model.id === current)) return current;
  if (models.some((model) => model.id === fallbackId)) return fallbackId;
  return models[0]?.id || fallbackId;
};

export const mentionLabelsForAsset = (asset) => {
  const aliases = Array.isArray(asset?.aliases)
    ? asset.aliases.map((alias) => String(alias).trim()).filter(Boolean)
    : [];
  if (aliases.length > 0) return aliases;
  const title = String(asset?.title || '').trim();
  return title ? [title] : [];
};

export const collectMentionLabels = (assets) => {
  const labels = [];
  (assets || []).forEach((asset) => {
    mentionLabelsForAsset(asset).forEach((label) => labels.push(label));
  });
  return labels.sort((a, b) => b.length - a.length);
};

export const mentionRegexFromLabels = (labels) => {
  const escaped = labels.map((label) => label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).filter(Boolean);
  if (escaped.length === 0) return null;
  return new RegExp(`(@(?:${escaped.join('|')}))(?=\\s|[.,;:!?]|$)`, 'gi');
};

export const assetByMention = (assets, raw) => {
  const key = String(raw || '')
    .replace(/^@/, '')
    .toLowerCase();
  return (assets || []).find((asset) =>
    mentionLabelsForAsset(asset).some((label) => label.toLowerCase() === key),
  );
};

export const matchedMentionLabels = (text, assets) => {
  const matches = [];
  (assets || []).forEach((asset) => {
    mentionLabelsForAsset(asset).forEach((label) => {
      const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`@${escaped}(?=\\s|[.,;:!?]|$)`, 'i');
      if (regex.test(text)) matches.push(label);
    });
  });
  return matches;
};

export const optionValues = (options) => options.map((option) => option.value);

export const getOptionsForModel = (modelName) =>
  MODEL_OPTIONS[modelName] || MODEL_OPTIONS['gpt-image-2'];
